import { type FC } from "react";

import { PageEventType } from "components/server-types";
import { t } from "i18n/i18n";
import { Chip } from "mds/components/Chip";
import { IconText } from "mds/components/IconText";
import { BookSectionTemplateIcon, PageListCheckIcon } from "mds/icons";

export type EventChipProps = {
  eventType: PageEventType.PUBLICATION | PageEventType.SUBMISSION_COLLECTION;
};

export const EventChip: FC<EventChipProps> = ({ eventType }) => {
  const isPublication = eventType === PageEventType.PUBLICATION;
  return (
    <Chip kind="hibiscus">
      <IconText
        iconStart={isPublication ? <BookSectionTemplateIcon /> : <PageListCheckIcon />}
        text={
          isPublication
            ? t("worksheet.timeline.event_publication")
            : t("worksheet.timeline.event_collection")
        }
      />
    </Chip>
  );
};
